import React from "react";
import { Html } from "react-konva-utils";
import { Frame } from "shared/datamodel/schemas/frame";
import { editingElementIdAtom, posScaleAtom } from "state-atoms/stage-atoms";
import { useAtomValue, useSetAtom } from "jotai";
import styles from "./frame-title-editable-text-input.module.css";

export default function FrameTitleEditableTextInput({
  element,
  onChangeElement,
}: {
  element: Frame;
  onChangeElement: (props: any, undoConfig: { shouldAdd: boolean; previousProps?: any }) => void;
}) {
  const posScale = useAtomValue(posScaleAtom);
  const setEditingElementId = useSetAtom(editingElementIdAtom);
  const { x, y, title } = {
    ...element,
  };

  const scale = posScale.scale;
  const s2 = Math.min(scale, 1);

  return (
    <Html
      transform={false}
      divProps={{
        style: {
          position: "fixed",
          top: 0,
          left: 0,
          transform: `translate(${(x - 3) * scale + posScale.x}px, ${(y - 30 / s2) * scale + posScale.y}px)
                    scale(${Math.max(scale, 1)})`,
          transformOrigin: "top left",
        },
      }}
    >
      <label className={styles.responsiveInputContainer} data-value={title || "Frame title"}>
        <input
          type="text"
          placeholder="Frame title"
          defaultValue={title}
          autoFocus
          onFocus={(e) => {
            e.currentTarget.select();
            (e.currentTarget.parentNode as any).dataset.value = e.currentTarget.value || "Frame title";
          }}
          onInput={(e) => {
            (e.currentTarget.parentNode as any).dataset.value = e.currentTarget.value || "Frame title";
          }}
          onKeyUp={(e) => {
            if (e.key === "Enter" || e.key === "Escape") {
              const newTitle = e.currentTarget.value.trim() || "Frame";
              onChangeElement({ title: newTitle }, { shouldAdd: true, previousProps: { title } });
              setEditingElementId(null);
            }
          }}
          onBlur={(e) => {
            const newTitle = e.currentTarget.value.trim() || "Frame";
            onChangeElement({ title: newTitle }, { shouldAdd: true, previousProps: { title } });
            setEditingElementId(null);
          }}
        />
      </label>
    </Html>
  );
}
